<div class="modal-content">
  <div class="modal-body">
    <lh-simple-bag-picker
      heading="HOW_MANY_BAGS_SHORT"
      subheading="CONFIRM_NUMBER_OF_BAGS_BEING_CHECKED_IN"
      subheadingInfo=""
      [maxBags]="50"
    ></lh-simple-bag-picker>
  </div>

  <div class="modal-footer">
    <lh-shared-ui-confirm-button
      id="confirmCheckIn"
      [slideCallToAction]="'SLIDE_TO_CHECK_IN' | translate"
      [clickCallToAction]="'CHECK_IN' | translate"
      (confirm)="checkIn()"
      [mode]="'primary'"
      [disabled]="!isCheckinAllowed"
      [isLoading]="isLoading"
    >
    </lh-shared-ui-confirm-button>
  </div>
</div>
